/* 張遼（字文遠） */
import { defineHero, U } from '../define.ts';

export default defineHero({
  id: 'zhangliao', name: '張遼', sub: '字文遠', faction: 'wei', role: '戰士', weapon: 'halberd',
  look: {
    weaponName: '月牙戟', skin: '#eec79c', hair: '#1b1a1f', beard: 'mustache', eye: 'fierce', horns: true, fx: '#a9d4ff',
    c: { armor: '#3b5a99', sleeve: '#2b3f6e', cloth: '#2a3c68', trim: '#c9a24e', pants: '#1f2740', boot: '#262a36', cape: '#23345e', belt: '#1a2238', metal: '#6c768d', plume: '#4f86e0', pole: '#3b4058' },
  },
  skills: [
    ['閃電盾', 'shield', '電場環繞一個單位 6 秒，每秒對它周圍的敵人造成 {26/34/43/51} 傷害。', { x: { k: 'zone', onUnit: 'any', r: 130, dur: 6, dps: [26, 34, 43, 51], fx: 'thunder' }, aim: U(480), cd: 25, mp: 120 }],
    ['暴雷擊', 'bolt', '擲出飛鎚，造成 {60/85/110/136} 傷害並打暈 {1/1.5/1.75/2} 秒。', { x: { k: 'nuke', dmg: [60, 85, 110, 136], cc: { stun: [1, 1.5, 1.75, 2] }, fx: 'thunder' }, aim: U(480) }],
    ['振作', 'passive', '生命回復速度 +{60/120/180/240}%。', { pv: { regenP: [60, 120, 180, 240] } }],
    ['尖刺鎧甲', 'passive', '防禦 +{4/8/12}，並把近戰普攻傷害的 {10/18/25}% 反彈給攻擊者。', { pv: { armor: [4, 8, 12], reflect: [10, 18, 25] } }],
  ],
});
